export interface DeveloperCredits {
  name: string
  url: string
}

export const DEVELOPER_CREDITS: DeveloperCredits = {
  name: 'Kauã Morais',
  url: 'https://moraiskaua.com.br',
}
